import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Immutable, { OrderedMap } from 'immutable';

import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';

const WebformSelect = (props) => {
  const { entity, customClasses, type, showOther, ...fieldProps } = props;
  const { t } = useTranslation();
  const title = entity.get('#title');
  const required = entity.get('#required');
  const description = entity.get('#description');
  const placeholder = entity.get('#placeholder');
  const requiredError = entity.get('#required_error');
  const key = entity.get('#webform_key');
  const otherLabel = entity.get('#other__option_label');
  const otherPlaceholder = entity.get('#other__placeholder');
  const webformId = entity.get('#webform');

  let options = entity.get('#options', Immutable.Map());

  const webformHasSelectLimitHandler = useSelector((state) => state.getIn(['webform', webformId, 'info', 'handlers', 'options_checkbox_limit'], false));
  const webformHasSelectLimitHandlerOptions = useSelector((state) => state.getIn(['uiInternal', 'additional_webform_elements_info', key, '#options'], options));

  // Load in more detailed #options when SelectLimitHandler is activated
  if (webformHasSelectLimitHandler) {
    const originalOptions = options.toJS();
    const additionalOptions = webformHasSelectLimitHandlerOptions.toJS();
    // Overwrite the label in the originalOptions
    for (const key in additionalOptions) {
      if (Object.hasOwnProperty.call(additionalOptions, key)) {
        const val = additionalOptions[key];
        if (key !== '') originalOptions[key] = val;
      }
    }
    // Set the new options
    options = new OrderedMap(originalOptions);
  }
  if (showOther) {
    options = options.set('__other__', 'Anders');
  }

  const validation = (value) => {
    let error;
    if (required && !value) {
      error = requiredError || t('Dit is een vereist veld.');
    }
    return error;
  };

  return (
    <div className="WebformSelect">
      <Select
        {...fieldProps}
        title={title}
        required={required}
        description={description}
        placeholder={placeholder}
        fieldName={key}
        validation={validation}
        touched={props.touched[key]}
        error={props.errors[key]}
        value={props.values[key]}
        options={options.toJS()}
        otherLabel={otherLabel}
        otherPlaceholder={otherPlaceholder}
      />
    </div>
  );
};

export default WebformSelect;
